import { Injectable, inject, PLATFORM_ID, CSP_NONCE } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { environment } from '@env/environment';
import { LogService } from '@app/core/log/log.service';

@Injectable({ providedIn: 'root' })
export class GigyaLoaderService {
  private readonly document = inject(DOCUMENT);
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  private readonly nonce = inject(CSP_NONCE, { optional: true });
  private loadPromise?: Promise<void>;

  load(): Promise<void> {
    if (!this.isBrowser) return Promise.resolve(); // no-op en SSR
    if (this.loadPromise) return this.loadPromise;
    if (environment.mockGigya) return Promise.resolve();

    const { apiKey } = environment.gigya;
    const errorURL = 'https://des-partners.aena.es/OpErrorPage';
    const consentURL = 'https://des-partners.aena.es/oidcConsentPage';
    this.loadPromise = this.injectScript(
      `https://cdns.gigya.com/JS/gigya.oidc.js?apiKey=${apiKey}`,
      JSON.stringify({ errorURL, consentURL }),
    ).catch((err) => {
      this.loadPromise = undefined;
      LogService.error('Error cargando Gigya OIDC SDK:', err);
      throw err;
    });
    return this.loadPromise;
  }

  private injectScript(src: string, innerConfig?: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const s = this.document.createElement('script');
      s.src = src;
      s.async = true;
      if (this.nonce) s.nonce = this.nonce;
      if (innerConfig) s.text = innerConfig;
      s.onload = () => resolve();
      s.onerror = () => reject(new Error(`Failed to load script: ${src}`));
      this.document.head.appendChild(s);
    });
  }
}
